var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#008009",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155 456 c-60 -28 -87 -56 -114 -116 -36 -79 -19 -183 42 -249 33 -36 115 -71 167 -71 52 0 134 35 167 71 34 37 63 110 63 159 0 52 -35 134 -71 167 -37 34 -110 63 -159 63 -27 0 -65 -10 -95 -24z m180 -15 c128 -58 164 -223 72 -328 -101 -115 -283 -88 -348 52 -79 171 104 354 276 276z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 306 c-26 -20 -13 -30 20 -15 20 10 32 10 52 0 33 -15 46 -5 20 15 -25 18 -67 18 -92 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294 306 c-26 -20 -13 -30 20 -15 20 10 32 10 52 0 33 -15 46 -5 20 15 -25 18 -67 18 -92 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 240 c0 -25 30 -77 59 -105 27 -25 41 -30 81 -30 42 0 54 5 84 34 32 31 65 96 54 106 -2 2 -26 -2 -53 -10 -61 -19 -109 -19 -171 0 -59 18 -54 17 -54 5z m115 -37 c28 -3 68 0 89 6 22 6 42 9 44 6 2 -2 -5 -19 -17 -38 -46 -74 -133 -75 -182 -1 -24 36 -24 48 -1 39 9 -4 40 -9 67 -12z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLol);
export default __webpack_public_path__ + "static/media/lol.75877f6d256afbdaa36bcefb88bf6765.svg";
export { ForwardRef as ReactComponent };